import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {kanUsersService} from "../../../../services/services/users";
import {User} from "../../../../../classes/user";
import {StateService} from "@uirouter/angular";
import {kanUserDialog} from "../../../dialogs/user-dialog/component";
import {MatDialog} from "@angular/material";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-user-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanUserListItem {
    @Input() user: User;
    @Input() searchText: string;
    @Output() refresh: EventEmitter<any> = new EventEmitter();
    public toggled: boolean = false;
    public selectedTab: number = 0;

    constructor(private stateService: StateService,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private userService: kanUsersService) {
    }

    ngOnInit(): void {
    }

    get role(): string {
        return this.authService.role;
    }

    public toggle() {
        this.toggled = !this.toggled;
    }

    public goToUserDetail(event: any) {
        this.stateService.go('app.admin.user', {id: this.user.id});
    }

    public agree(event: any) {
        console.log('agree', this.user);
        this.user.agree = true;
        this.user.agreeDate = new Date();

        this.userService.updateUser(this.user)
            .then(() => {
                this.refresh.emit();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public editUserDialog(event: any) {
        let dialogRef = this.dialog.open(kanUserDialog, {
            data: {
                user: this.user
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.refresh.emit();
            }
        });
    }

    public removeUser(event: any) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.userService.removeUser(this.user)
                    .then((data) => {
                        this.refresh.emit();
                    });
            }
        });
    }

    public tabChanged(index: number) {
        this.selectedTab = index;
    }

    public isActiveMember() {
        return this.user ? (this.user.dogs || []).some(dog => dog.membershipActive) : false;
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/user/list-item/component.ts